import { render, staticRenderFns } from "./LeonidaPrenotazioneEdit.vue?vue&type=template&id=741f1550"
import script from "./LeonidaPrenotazioneEdit.vue?vue&type=script&lang=js"
export * from "./LeonidaPrenotazioneEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports